
import { useFileCompletionMarker } from "./useFileCompletionMarker";
import { useQuizAttemptChecker } from "./useQuizAttemptChecker";
import { useQuizProgressSync } from "./useQuizProgressSync";
import { useProgressShares } from "./useProgressShares";

export function useCompletionMarker(resourceId?: string, fileId?: string) {
  const { calculateProgress, updateResourceShares } = useProgressShares(resourceId);
  const fileCompletionMarker = useFileCompletionMarker(resourceId, fileId);
  const quizProgressSync = useQuizProgressSync(resourceId, fileId);
  const quizAttemptChecker = useQuizAttemptChecker();

  // Mark a file as completed, with support for checking quiz/linking attempts
  const markAsCompleted = async () => {
    if (!resourceId || !fileId) {
      return Promise.reject(new Error('Missing required parameters'));
    }
    
    try {
      // Check for any passed linking attempts
      const hasPassedLinkingAttempt = await quizAttemptChecker.checkLinkingAttempt(fileId);
      
      // Check for any passed quiz attempts
      const hasPassedQuizAttempt = await quizAttemptChecker.checkQuizAttempt(fileId);
      
      // If there's a passed linking attempt or quiz attempt, ensure we reflect that
      if (hasPassedLinkingAttempt || hasPassedQuizAttempt) {
        console.log("Found passed attempt, ensuring training progress is updated");
      }

      // Mark the file as completed
      await fileCompletionMarker.markAsCompleted();
      
      // Calculate progress and update resource shares
      const calculatedProgress = await calculateProgress();
      await updateResourceShares(calculatedProgress);
      
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    }
  };

  return {
    ...fileCompletionMarker,
    syncQuizProgress: quizProgressSync.syncQuizProgress,
    markAsCompleted
  };
}
